// store
// const chainAdd = () =>
//   import(/* webpackChunkName: 'storeChainAdd' */ '@views/home/store/storeChain/chainAdd/index')
// const chainEdit = () =>
//   import(/* webpackChunkName: 'storeChainEdit' */ '@views/home/store/storeChain/chainEdit/index')
const employeeInfo = () =>
  import(/* webpackChunkName: 'storeOperation' */ '@views/home/store/storeEmployee/employeeInfo/index')

const routes = [
  {
    path: '/store',
    component: () => import('@views/home/index/index'),
    redirect: { name: 'homeStoreManage' },
    name: 'store',
    hidden: true,
    meta: {
      keepAlive: true,
      title: '店铺管理',
      icon: 'store_manage',
      first: true,
      resourceCode: 'STORE_MANAGE',
      No: 7
    },
    children: [
      {
        path: 'manage',
        component: () => import('@views/home/store/storeManage/index'),
        name: 'homeStoreManage',
        meta: {
          keepAlive: true,
          title: '门店管理',
          second: false,
          resourceCode: 'STORE_MANAGE01',
          No: 0
        }
      },
      {
        path: 'employee',
        name: 'StoreEmployee',
        component: () => import('@components/core/MqlLayout/MqlMiddlePage/index'),
        redirect: { name: 'homeStoreEmployeeList' },
        meta: {
          keepAlive: true,
          title: '员工管理',
          second: false,
          resourceCode: 'STORE_MANAGE01',
          No: 1
        },
        children: [
          {
            path: 'list',
            component: () => import('@views/home/store/storeEmployee/employeeList/index'),
            name: 'homeStoreEmployeeList',
            meta: { keepAlive: true, title: '员工管理' }
          },
          {
            path: 'detail/:id',
            component: employeeInfo,
            name: 'homeStoreEmployeeDetail',
            meta: { keepAlive: true, title: '员工详情' }
          },
          {
            path: 'add',
            component: () => import('@views/home/store/storeEmployee/employeeEdit/index'),
            name: 'homeStoreEmployeeAdd',
            meta: { keepAlive: true, title: '添加员工' }
          },
          {
            path: 'royalty',
            component: () => import('@views/home/store/storeEmployee/employeeRoyalty/index'),
            name: 'homeStoreEmployeeRoyalty',
            meta: { keepAlive: true, title: '提成设置' }
          },
          {
            path: 'checkingIn',
            component: () =>
              import('@views/home/store/storeEmployee/employeeAttendanceRecords/index'),
            name: 'employeeAttendance',
            meta: {
              keepAlive: true,
              title: '考勤记录'
            }
          }
        ]
      },
      {
        path: 'operation',
        component: () => import('@views/home/store/storeOperation/index'),
        name: 'homeStoreOperation',
        meta: {
          keepAlive: true,
          title: '操作记录',
          second: false,
          resourceCode: 'STORE_MANAGE03',
          No: 2
        }
      },
      {
        path: 'outlay',
        component: () => import('@views/home/store/storeOutlay/index'),
        name: 'homeStoreOutlay',
        meta: {
          keepAlive: true,
          title: '支出管理',
          second: false,
          resourceCode: 'STORE_MANAGE04',
          No: 3
        }
      },
      {
        path: 'feedback',
        component: () => import('@views/home/store/storeFeedback/index'),
        name: 'storeFeedback',
        meta: {
          keepAlive: true,
          title: '客户留言',
          second: false,
          resourceCode: 'STORE_MANAGE05',
          No: 4
        }
      }
    ]
  }
  // {
  //     path: 'store',
  //     component: MqlMiddlePage,
  //     redirect: { name: 'homeStoreChain' },
  //     children: [
  //         {
  //             path: 'chain',
  //             component: storeChain,
  //             name: 'homeStoreChain',
  //             meta: {
  //                 keepAlive: true,
  //                 title: '连锁管理'
  //             }
  //         },
  //         {
  //             path: 'chain/add',
  //             component: chainAdd,
  //             name: 'homeStoreChainAdd',
  //             meta: {
  //                 keepAlive: true,
  //                 title: '添加门店'
  //             }
  //         },
  //         {
  //             path: 'chain/edit',
  //             component: chainEdit,
  //             name: 'homeStoreChainEdit',
  //             meta: {
  //                 keepAlive: true,
  //                 title: '编辑门店'
  //             }
  //         }
  //     ]
  // },
  // {
  //     path: 'store/brand',
  //     component: storeBrand,
  //     name: 'homeStoreBrand',
  //     meta: {
  //         keepAlive: true
  //     }
  // },
  // {
  //     path: 'store/employee',
  //     component: MqlMiddlePage,
  //     redirect: { name: 'homeStoreEmployeeList' },
  //     meta: {
  //         keepAlive: true,
  //         title: '员工管理'
  //     },
  //     children: [
  //         {
  //             path: 'list',
  //             component: employeeList,
  //             name: 'homeStoreEmployeeList',
  //             meta: {
  //                 keepAlive: true
  //             }
  //         },
  //         {
  //             path: 'detail/:id',
  //             component: employeeInfo,
  //             name: 'homeStoreEmployeeDetail',
  //             meta: {
  //                 keepAlive: true,
  //                 title: '员工详情'
  //             }
  //         },
  //         {
  //             path: 'edit/:id',
  //             component: employeeEdit,
  //             name: 'homeStoreEmployeeEdit',
  //             meta: {
  //                 keepAlive: true,
  //                 title: '编辑员工'
  //             }
  //         },
  //         {
  //             path: 'add',
  //             component: employeeEdit,
  //             name: 'homeStoreEmployeeAdd',
  //             meta: {
  //                 keepAlive: true,
  //                 title: '添加员工'
  //             }
  //         },
  //         {
  //             path: 'royalty/:id',
  //             component: employeeRoyalty,
  //             name: 'homeStoreEmployeeRoyalty',
  //             meta: {
  //                 keepAlive: true,
  //                 title: '提成设置'
  //             }
  //         }
  //     ]
  // },
  // {
  //     path: 'store/manage',
  //     component: storeManage,
  //     name: 'homeStoreManage',
  //     meta: {
  //         name: 'homeStoreManage',
  //         keepAlive: true
  //     }
  // },
  // {
  //     path: 'store/operation',
  //     component: storeOperation,
  //     name: 'homeStoreOperation',
  //     meta: {
  //         name: 'homeStoreOperation',
  //         keepAlive: true
  //     }
  // }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/store.js